import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { MealTiersFilterEntity } from '../../domain/entities/MealTiersFilterEntity'

export class MealTiersFilterModel implements MealTiersFilterEntity {
  id?: number
  name?: string
  searchWord?: string
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean

  constructor(dataEntity: MealTiersFilterEntity) {
    mapEntityProperties<MealTiersFilterEntity>(this, dataEntity)
  }
}
